/* eslint-disable no-underscore-dangle */
import Cookie from 'js-cookie';

import {
  EVIDON_GDPR_CONSENT_COOKIE,
  EVIDON_SUPPRESS_GDPR_NOTIFICATION_COOKIE,
  EVIDON_CONSENT_DECLINE_EXPIRATION_DAYS,
} from 'app/features/footer/constants';
import { windowLocaleFromPath } from 'app/router/selectors';

const declineEvidonConsent = () => {
  window.evidon?.notice?.dropSuppressionCookie(
    EVIDON_CONSENT_DECLINE_EXPIRATION_DAYS,
  );

  Cookie.set(EVIDON_SUPPRESS_GDPR_NOTIFICATION_COOKIE, '1', {
    path: `/${windowLocaleFromPath()}`,
    expires: EVIDON_CONSENT_DECLINE_EXPIRATION_DAYS,
  });
};

const overrideEvidonMethods = () => {
  if (!window.evidon?.notice) {
    return;
  }
  // Override the original `_isConsentGiven` method
  // to explicitly check if the consent cookie is applied to GDPR
  window.evidon.notice._isConsentGiven = () =>
    Boolean(Cookie.get(EVIDON_GDPR_CONSENT_COOKIE));

  // Override the original `_getSuppressionCookie` method
  // to explicitly check if the suppression cookie is applied to GDPR
  window.evidon.notice._getSuppressionCookie = () =>
    Boolean(Cookie.get(EVIDON_SUPPRESS_GDPR_NOTIFICATION_COOKIE));

  // Show the consent notice only if necessary
  window.evidon.notice.showNotice();
};

const dropGDPRSuppressionCookie = days => {
  const dateObj = { date: new Date() };
  const date = new Date();

  date.setDate(date.getDate() + days);

  const expirationDate = date.toUTCString();
  const path = window.evidon.notice._getConsentCookieDomainPath();
  const domain = window.evidon.notice._getConsentCookieDomain();

  window.evidon.notice._writeCookie(
    EVIDON_SUPPRESS_GDPR_NOTIFICATION_COOKIE,
    JSON.stringify(dateObj),
    expirationDate,
    path,
    domain,
  );
};

const onEvidonSettingsLoaded = () => () => {
  if (window.evidon?.notice?.isGDPR()) {
    window.evidon.consentDeclinedCallback = declineEvidonConsent;
    overrideEvidonMethods();
    window.evidon.priorConsentCallback = () => {
      dropGDPRSuppressionCookie(EVIDON_CONSENT_DECLINE_EXPIRATION_DAYS);
    };
  }
};

export default onEvidonSettingsLoaded;
